import { render, staticRenderFns } from "./TopRanking.vue?vue&type=template&id=4d4ab956&scoped=true&"
import script from "./TopRanking.vue?vue&type=script&lang=js&"
export * from "./TopRanking.vue?vue&type=script&lang=js&"
import style0 from "./TopRanking.vue?vue&type=style&index=0&id=4d4ab956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ab956",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VImg,VRow,VSelect})
